import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import { BackendApi } from "../../api/api.ts";
import { useUploadQueue } from "./useUploadQueue.ts";

export type UploadQueueContextValue = ReturnType<typeof useUploadQueue> & {
    settledRunCount: number;
};

const UploadQueueContext = createContext<UploadQueueContextValue | null>(null);

export function useUploadQueueContext(): UploadQueueContextValue | null {
    return useContext(UploadQueueContext);
}

export function UploadQueueProvider({ children }: { children: ReactNode }) {
    const api = useMemo(() => new BackendApi(), []);
    const [settledRunCount, setSettledRunCount] = useState(0);
    const queue = useUploadQueue({ api, onAllSettled: () => setSettledRunCount((count) => count + 1) });

    return (
        <UploadQueueContext.Provider value={{ ...queue, settledRunCount }}>
            {children}
        </UploadQueueContext.Provider>
    );
}
